import { ReactNode, useReducer } from 'react';
import { initialState, LoaderContext, loaderReducer } from './loader-context';

type LoaderProviderProps = { children: ReactNode };

export function LoaderProvider({ children }: LoaderProviderProps) {
  const [state, dispatch] = useReducer(loaderReducer, initialState);
  const value = { state, dispatch };
  return (
    <LoaderContext.Provider value={value}>{children}</LoaderContext.Provider>
  );
}
